/*
 *
 * CreateSurveyModal constants
 *
 */

export const CREATE_SURVEY = 'app/CreateSurveyModal/CREATE_SURVEY';
export const CREATE_SURVEY_SUCCESS =
  'app/CreateSurveyModal/CREATE_SURVEY_SUCCESS';
export const CREATE_SURVEY_ERROR = 'app/CreateSurveyModal/CREATE_SURVEY_ERROR';

export const SURVEY_STEPS = {
  SURVEY_NAME: 'SURVEY_NAME',
  AUDIENCE_SELECTION: 'AUDIENCE_SELECTION',
  TEMPLATE_VARIABLES: 'TEMPLATE_VARIABLES',
  EXPERT: 'EXPERT',
  EXPERT_BOOK: 'EXPERT_BOOK',
  PEEQ_SELECT: 'PEEQ_SELECT',
  CREATION_LOADER: 'CREATION_LOADER',
};

export const BACKDROP_CLASSES = {
  REGULAR_SURVEY: 'create-survey-modal-open-regular',
  DISTRIBUTION: 'create-survey-modal-open-distribution',
  PEEQ_SURVEY: 'create-survey-modal-open-peeq',
};

export const SURVEY_FLOW = {
  REGULAR: 'REGULAR',
  THIRD_PARTY: 'THIRD_PARTY',
  TEMPLATE: 'TEMPLATE',
};
